import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import {validNip} from '../../../shared/validator/nip-validator';
import {validRegon} from '../../../shared/validator/regon-validator';
import { Observable, of, ReplaySubject} from 'rxjs';
import {
  COMPANY_ASF_PREMIUM,
  CONTRACT_STATUS_ACTIVE,
  DICT_TYPE_FORM_OF_BUSINESS,
  DICT_TYPE_KRK_PAYER,
  DICT_TYPE_PARTNER_TAGS,
  DICT_TYPE_PARTNER_TAGS_PARTNER_CONTRACT_OF_MANDATE,
  DICT_TYPE_SEX,
  DictService,
  FORM_OF_BUSINESS_PARTNERSHIP,
  FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP,
  KRK_PAYER_ASF,
  LEGAL_FORM_NATURAL_PERSON,
  PARTNER_TAGS_PROFIT,
  SEX_FEMALE,
  SEX_MALE,
  FORM_OF_BUSINESS_COOPERATIVE,
  FORM_OF_BUSINESS_GENERAL_PARTNERSHIP,
  FORM_OF_BUSINESS_LIMITED_LIABILITY_PARTNERSHIP,
  FORM_OF_BUSINESS_LIMITED_PARTNERSHIP,
  FORM_OF_BUSINESS_PARTNERSHIP_LIMITED_BY_SHARES,
  FORM_OF_BUSINESS_JOINT_STOCK_COMPANY,
  FORM_OF_BUSINESS_PRIVATE_LIMITED_COMPANY,
  PARTNER_TAGS_GOOD_AGENT,
  FORM_OF_BUSINESS_FOREIGN_ACTIVITIES,
  DICT_TYPE_LEGAL_FORM, LEGAL_FORM_LEGAL_PERSON, FORM_OF_BUSINESS_ASSOCIATION, FORM_OF_BUSINESS_NONE_PROPRIETORSHIP,
  AUTOMATIC_PARTNER_TAGS,
  DYNAMIC_DICTIONARY_FUNCTION,
} from '../../../shared/services/dict.service';
import {ArrayValidators} from '../../../shared/validator/array-validators';
import {PartnerService} from '../../../shared/services/partner.service';
import {debounceTime, delay, first, map, skipUntil, take, takeUntil, tap} from 'rxjs/operators';
import {Uuid} from '../../../shared/interface/response/uuid';
import {MatSnackBar} from '@angular/material/snack-bar';
import {HttpErrorResponse} from '@angular/common/http';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {Partner} from '../../../shared/interface/partner';
import {EmailAddress} from '../../../shared/interface/email-address';
import {PhoneNumber} from '../../../shared/interface/phone-number';
import {PartnerRepresentation} from '../../../shared/interface/partner-representation';
import {Router} from '@angular/router';
import {PhonePipe} from '../../../shared/pipe/phone-number';
import {Dictionary} from '../../../shared/interface/dictionary';
import {validIban} from '../../../shared/validator/iban-validator';
import {Address} from '../../../shared/interface/address';
import * as uuid from 'uuid';
import {validPhoneNumber} from '../../../shared/validator/phone-validator';
import {AuthService} from '../../../shared/services/auth.service';
import {Profile} from '../../../shared/interface/profile';
import {validPesel} from "../../../shared/validator/pesel-validator";
import {PeselHelperService} from "../../../shared/services/pesel-helper.service";
import moment from "moment/moment";
import {Contract} from "../../../shared/interface/contract";
import {CommissionSettlementService} from "../../../shared/services/commission-settlement.service";
import {OfwcaService} from "../../../shared/services/ofwca.service";
import {Ofwca} from "../../../shared/interface/ofwca";
import {Invoice} from "../../../shared/interface/invoice";
import {CommissionSettlement} from "../../../shared/interface/commission-settlement";
import {CountedAndPaginated} from "../../../shared/interface/response/counted-and-paginated";
import {ListResponse} from "../../../shared/interface/response/list-response";
import {OfwcaRegistrationInfo} from "../../../shared/interface/ofwca-registration-info";
import {RegistrationService} from "../../../shared/services/registration.service";
import {PartnerBusinessEntities} from "../../../shared/interface/partner-business-entities";
import {PartnerGus} from "../../../shared/interface/partner-gus";
import {Submissions} from "../../../shared/interface/submissions";
import {CommissionAnnex} from "../../../shared/interface/commission-annex";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {co, em} from "@fullcalendar/core/internal-common";
import {Registration} from "../../../shared/interface/registration";

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() partner?: Observable<Partner>;
  @Input() disableBreadcrumbs = false;
  @Output() closeModification = new EventEmitter<any>();
  @Output() disableContract = new EventEmitter<boolean>();

  readonly DYNAMIC_DICTIONARY_FUNCTION = DYNAMIC_DICTIONARY_FUNCTION;

  readonly FORM_OF_BUSINESS_LEGAL_PERSON = [
    FORM_OF_BUSINESS_PARTNERSHIP,
    FORM_OF_BUSINESS_COOPERATIVE,
    FORM_OF_BUSINESS_GENERAL_PARTNERSHIP,
    FORM_OF_BUSINESS_LIMITED_LIABILITY_PARTNERSHIP,
    FORM_OF_BUSINESS_LIMITED_PARTNERSHIP,
    FORM_OF_BUSINESS_PARTNERSHIP_LIMITED_BY_SHARES,
    FORM_OF_BUSINESS_JOINT_STOCK_COMPANY,
    FORM_OF_BUSINESS_PRIVATE_LIMITED_COMPANY,
    FORM_OF_BUSINESS_FOREIGN_ACTIVITIES,
    FORM_OF_BUSINESS_ASSOCIATION
  ];

  readonly FORM_OF_BUSINESS_NATURAL_PERSON = [
    FORM_OF_BUSINESS_NONE_PROPRIETORSHIP,
    FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP,
  ];

  readonly AUTOMATIC_TAGS = AUTOMATIC_PARTNER_TAGS;

  phonePipe = PhonePipe;
  partnerObject?: Partner;
  partnerUuid?: string;
  partnerGus: ReplaySubject<PartnerGus> = new ReplaySubject<PartnerGus>(1);
  partnerGusObject?: PartnerGus = null;
  hideRepresentation = false;
  hideBusinessEntities = false;
  hidePartner = false;
  processingRequest = false;
  enableSaveButton = false;
  errors: any = {};
  // emails: FormGroup[] = [];
  // billingEmails: FormGroup[] = [];
  // marketingEmails: FormGroup[] = [];
  // productEmails: FormGroup[] = [];
  phones: FormGroup[] = [];
  billingPhones: FormGroup[] = [];
  marketingPhones: FormGroup[] = [];
  representationFormArray: FormGroup[] = [];
  businessEntitiesFormArray: FormGroup[] = [];
  headquartersAddress: FormGroup;
  communicationAddress: FormGroup;
  legalForm: FormControl;
  formOfBusiness: FormControl;
  tags: FormControl;
  ofwca: FormControl;
  assetsRegionalControl: FormControl;
  lifeRegionalControl: FormControl;
  parentPartnerControl: FormControl;
  foreignActivitiesControl: FormControl;
  foreignActivitiesHeadquartersAddress: FormGroup;
  partnerForm: FormGroup;
  requiredKrsNumber = false;
  radioOff = false;
  ofwcaPartner: FormControl;
  ofwcaObject: Ofwca;
  ofwcaControl: FormControl;
  ofwcas: Ofwca[] = [];
  ofwcaSubject: ReplaySubject<CountedAndPaginated<Ofwca>> = new ReplaySubject(1);
  ofwcaFirstName: FormControl;
  ofwcaSecondName: FormControl;
  ofwcaLastName: FormControl;
  ofwcaFamilyName: FormControl;
  ofwcaMothersMaidenName: FormControl;
  ofwcaMothersName: FormControl;
  ofwcaFathersName: FormControl;
  ofwcaPesel: FormControl;
  ofwcaBirthPlace: FormControl;
  ofwcaBirthDate: FormControl;
  ofwcaSex: FormControl;
  ofwcaEducation: FormControl;
  ofwcaStatus: FormControl;
  ofwcaId: FormControl;
  ofwcaContractId: FormControl;
  last_selection = null;
  settlementsSubject: ReplaySubject<CountedAndPaginated<CommissionSettlement>> = new ReplaySubject(1);
  accountNumber: FormControl;
  showAllContracts = false;
  contractControl: FormControl;
  ofwcaContracts: ReplaySubject<Contract[]> = new ReplaySubject<Contract[]>(1);
  ofwcaRegistrationInfo?: OfwcaRegistrationInfo;
  contractCompanyId: ReplaySubject<number> = new ReplaySubject<number>(1);
  selectedContract?: Contract;
  legalFormNatural = false;
  legalFormLegal = true;
  items: PartnerGus[] = [];
  gusStatus: FormControl;
  statusGus: Dictionary = null;
  overcommissionPartnerControl: FormControl;
  formOfBusinessNonePartnership = false;
  ofwcaSelect:  Ofwca = null;
  userPermissions: ReplaySubject<UserPermissions>;
  userPermissionss: UserPermissions;
  nonEditableTags = [];
  mainEmails:  FormGroup[] = [];
  additionalEmails:  FormGroup[] = [];
  mainPhones:  FormGroup[] = [];
  additionalPhones:  FormGroup[] = [];


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private dictService: DictService,
    private partnerService: PartnerService,
    private snackBar: MatSnackBar,
    private formHelper: FormHelperService,
    private router: Router,
    private fb: FormBuilder,
    private auth: AuthService,
    private peselHelper: PeselHelperService,
    private ofwcaService: OfwcaService,
    private commissionSettlementService: CommissionSettlementService,
    private registrationService: RegistrationService,
    private snack: MatSnackBar,
  ) {
    this.userPermissions = this.auth.getUserPermissions();

    this.partnerForm = fb.group({
      legalForm: this.legalForm = fb.control('', [Validators.required]),
      formOfBusiness: this.formOfBusiness = fb.control('', [Validators.required]),
      fullName: fb.control('', [Validators.required]),
      shortName: fb.control('', [Validators.required]),
      nip: fb.control('', [Validators.required, validNip()]),
      regon: fb.control('', [Validators.required, validRegon()]),
      krs: fb.control('', []),
      accountNumber: fb.control('', [validIban()]),
      vatPayer: fb.control(false, []),
      activeVatPayer: fb.control(false, []),
      contestMessageConsent: fb.control(false, []),
      productMessageConsent: fb.control(false, []),
      mainEmails:  fb.array(this.mainEmails, [ArrayValidators.minLength(1) ]),
      additionalEmails: fb.array(this.additionalEmails),
      owner: this.ofwca = fb.control(''),
      assetsRegional: this.assetsRegionalControl = fb.control(''),
      lifeRegional: this.lifeRegionalControl = fb.control(''),
      communicationAddressSameAsHeadquarters: fb.control(true),
      headquartersAddress: this.headquartersAddress = this.formHelper.generateAddressFormGroup(),
      communicationAddress: this.communicationAddress = this.formHelper.generateAddressFormGroup(),
      representation: fb.array(this.representationFormArray, [ArrayValidators.minLength(1)]),
      businessEntities: fb.array(this.businessEntitiesFormArray, [ArrayValidators.minLength(2)]),
      tags: this.tags = fb.control([]),
      verified: fb.control(false),
      note: fb.control(''),
      profitNumber: fb.control(''),
      parentPartner: this.parentPartnerControl = fb.control(''),
      checkoutMethod: fb.control(false),
      selfBilling: fb.control(false),
      hiperioEmail: fb.control(''),
      hiperioLogin: fb.control(''),
      ofwcaSelect: this.ofwcaControl = fb.control(''),
      ofwcaFirstName: this.ofwcaFirstName = fb.control('', [Validators.required]),
      ofwcaSecondName: this.ofwcaSecondName = this.fb.control(''),
      ofwcaPartner: this.ofwcaPartner = fb.control('0', []),
      ofwcaLastName: this.ofwcaLastName = this.fb.control('', [Validators.required]),
      ofwcaPesel: this.ofwcaPesel = this.fb.control('', [Validators.required, validPesel()]),
      withoutPesel: this.fb.control(false),
      companyOfwcaControl: this.fb.control(false),
      ofwcaFamilyName: this.ofwcaFamilyName = this.fb.control(''),
      ofwcaMothersMaidenName: this.ofwcaMothersMaidenName = this.fb.control(''),
      ofwcaMothersName: this.ofwcaMothersName = this.fb.control(''),
      ofwcaFathersName: this.ofwcaFathersName = this.fb.control(''),
      ofwcaBirthPlace: this.ofwcaBirthPlace = this.fb.control(''),
      ofwcaBirthDate: this.ofwcaBirthDate = this.fb.control('', [Validators.required]),
      ofwcaSex: this.ofwcaSex = this.fb.control('', [Validators.required]),
      ofwcaEducation: this.ofwcaEducation = this.fb.control('', [Validators.required]),
      ofwcaStatus: this.ofwcaStatus = this.fb.control(''),
      ofwcaId: this.ofwcaId = this.fb.control(''),
      ofwcaContractId: this.ofwcaContractId = this.fb.control(''),
      showAllContracts: fb.control(false),
      contract: this.contractControl = fb.control(''),
      gusStatus: this.gusStatus = this.fb.control(''),
      hasPkd: fb.control(false),
      invoiceGenerateBlockAsf: fb.control(false),
      invoiceGenerateBlockPremium: fb.control(false),
      settlementSendBlockAsf: fb.control(false),
      settlementSendBlockPremium: fb.control(false),
      invoiceAddBlockAsf: fb.control(false),
      invoiceAddBlockPremium: fb.control(false),
      foreignActivities: this.foreignActivitiesControl = fb.control(false),
      foreignActivitiesNip: fb.control('', []),
      foreignActivitiesRegon: fb.control('', []),
      foreignActivitiesHeadquartersAddress: this.foreignActivitiesHeadquartersAddress = this.formHelper.generateAddressFormGroup(false, false, false, true),
      newPartner: fb.control(false),
      overcommissionPartner: this.overcommissionPartnerControl = fb.control(''),
      mainPhones:  fb.array(this.mainPhones, [ArrayValidators.minLength(1)]),
      additionalPhones: fb.array(this.additionalPhones),
    }, {
      validators: [
        ArrayValidators.atLeastOneSelectedInArrays('lead', ['mainEmails', 'additionalEmails']),
        ArrayValidators.atLeastOneSelectedInArrays('billing', ['mainEmails', 'additionalEmails'])
      ]
    });
    this.communicationAddress.disable();
    this.foreignActivitiesHeadquartersAddress.disable();
    this.headquartersAddress.enable();
  }
  ngOnInit(): void {
    this.auth.getUserPermissions()
      .subscribe((userPermissions: UserPermissions) => {
        this.userPermissionss = userPermissions;
      });
    this.partnerForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.partnerForm.valid);

    this.partnerForm.get('formOfBusiness').valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dictId: number) => {
        this.dictService.getKey(dictId)
          .subscribe((dictKey: string) => {
            if (dictKey === FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP
              || dictKey === FORM_OF_BUSINESS_NONE_PROPRIETORSHIP
              || this.ofwcaPartner.value === '1') {
              this.representationFormArray.splice(0, this.representationFormArray.length);
              this.updateRepresentationFormArray();
              this.hideRepresentation = true;
              this.partnerForm.get('representation').disable();
            } else {
              this.hideRepresentation = false;
              this.partnerForm.get('representation').enable();
            }
            if (dictKey === FORM_OF_BUSINESS_PARTNERSHIP ) {
              this.businessEntitiesFormArray.splice(0, this.businessEntitiesFormArray.length);
              this.updateBusinessEntitiesFormArray();
              this.hideBusinessEntities = true;
              this.partnerForm.get('businessEntities').enable();
            } else {
              this.hideBusinessEntities = false;
              this.partnerForm.get('businessEntities').disable();
            }
          });
      });
    this.partnerForm.get('withoutPesel').valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((withoutPesel: boolean) => this.updatePeselControl(withoutPesel));

    this.partnerForm.get('ofwcaPartner').valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((ofwcaPartner: any) => {
        this.changeOfwcaPartner(ofwcaPartner);
        if (ofwcaPartner === '1') {
          this.addTags(DICT_TYPE_PARTNER_TAGS_PARTNER_CONTRACT_OF_MANDATE, DICT_TYPE_PARTNER_TAGS);
        // } else {
        //   this.removeTags(DICT_TYPE_PARTNER_TAGS_PARTNER_CONTRACT_OF_MANDATE, DICT_TYPE_PARTNER_TAGS);
        }
      });
    this.partnerForm.get('ofwcaPesel').valueChanges
      .pipe(
        debounceTime(400),
        takeUntil(this.destroyed$),
        skipUntil(this.initialized)
      )
      .subscribe((ofwcaPesel: string) => this.updateDataBasedOnPesel(ofwcaPesel));

    this.partnerForm.get('legalForm').valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dictId: number) => {
        this.dictService.getKey(dictId)
          .subscribe((dictKey: string) => {
            if (dictKey === LEGAL_FORM_NATURAL_PERSON) {
              // this.dictService.getId(FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP, DICT_TYPE_FORM_OF_BUSINESS)
              //   .subscribe((resultDictId: number) => {
              //     this.partnerForm.get('formOfBusiness').setValue(resultDictId);
              //   });
              //
              // this.partnerForm.get('formOfBusiness').disable();
              this.partnerForm.get('legalForm').clearValidators();
              this.legalFormNatural = true;
              this.legalFormLegal = false;

            } else {
              this.dictService.getId(FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP, DICT_TYPE_FORM_OF_BUSINESS)
                .subscribe((resultDictId: number) => {
                  this.partnerForm.get('formOfBusiness').setValue(resultDictId);
                });
              this.partnerForm.get('formOfBusiness').enable();
              this.partnerForm.get('legalForm').setValidators([Validators.required]);
              this.legalFormNatural = false;
              this.legalFormLegal = true;
              this.dictService.getId(FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP, DICT_TYPE_FORM_OF_BUSINESS)
                .subscribe((resultDictId: number) => {
                  if ( this.partnerForm.get('formOfBusiness').value === resultDictId) {
                    this.partnerForm.get('formOfBusiness').reset();
                  }
                });
            }
          });
      });

    this.partnerForm.get('communicationAddressSameAsHeadquarters').valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => {
        if (val) {
          this.communicationAddress.disable();
        } else {
          this.communicationAddress.enable();
        }
      });

    this.partnerForm.get('foreignActivities').valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => {
        if (val) {
          this.partnerForm.get('nip').setValidators([]);
          this.partnerForm.get('regon').setValidators([]);
          this.partnerForm.get('foreignActivitiesNip').setValidators([Validators.required]);
          this.partnerForm.get('foreignActivitiesRegon').setValidators([Validators.required]);
          this.partnerForm.get('nip').reset();
          this.partnerForm.get('regon').reset();
          this.foreignActivitiesHeadquartersAddress.enable();
          this.headquartersAddress.disable();
          this.dictService.getId(LEGAL_FORM_LEGAL_PERSON, DICT_TYPE_LEGAL_FORM)
            .subscribe((resultDictId: number) => {
              this.partnerForm.get('legalForm').setValue(resultDictId);
            });
          this.dictService.getId(FORM_OF_BUSINESS_FOREIGN_ACTIVITIES, DICT_TYPE_FORM_OF_BUSINESS)
            .subscribe((resultDictId: number) => {
              this.partnerForm.get('formOfBusiness').setValue(resultDictId);
            });
          this.requiredKrsNumber = false;
          this.partnerForm.get('krs').setValidators([]);

        } else {
          this.partnerForm.get('nip').setValidators([Validators.required, validNip()]);
          this.partnerForm.get('regon').setValidators([Validators.required, validRegon()]);
          this.partnerForm.get('foreignActivitiesNip').setValidators([]);
          this.partnerForm.get('foreignActivitiesRegon').setValidators([]);
          this.partnerForm.get('foreignActivitiesNip').reset();
          this.partnerForm.get('foreignActivitiesRegon').reset();
          this.foreignActivitiesHeadquartersAddress.disable();
          this.headquartersAddress.enable();
        }
      });

    this.partnerForm.get('showAllContracts').valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((val: boolean) => this.showAllContracts = val);
    // this.ofwcaControl.valueChanges
    //   .pipe(takeUntil(this.destroyed$))
    //   .subscribe((ofwcaId: string) => {
    //     this.registrationService.getOfwcaRegistrationInfo(ofwcaId)
    //       .subscribe((ofwcaRegistrationInfo: OfwcaRegistrationInfo) => {
    //
    //           this.ofwcaContracts.next(ofwcaRegistrationInfo.contracts);
    //
    //           let activeContract = null;
    //           let activeAsfPremiumContract = null;
    //           let asfPremiumContract = null;
    //           ofwcaRegistrationInfo.contracts.forEach((contract: Contract) => {
    //             if (contract.company?.key === COMPANY_ASF_PREMIUM) {
    //               asfPremiumContract = contract;
    //
    //               if (contract.status?.key === CONTRACT_STATUS_ACTIVE) {
    //                 activeAsfPremiumContract = contract;
    //               }
    //             }
    //
    //             if (contract.status?.key === CONTRACT_STATUS_ACTIVE) {
    //               activeContract = contract;
    //             }
    //           });
    //
    //           if (null !== activeAsfPremiumContract) {
    //             this.contractControl.setValue(activeAsfPremiumContract.uuid);
    //             this.contractChanged(activeAsfPremiumContract);
    //           } else if (null !== activeContract) {
    //             this.contractControl.setValue(activeContract.uuid);
    //             this.contractChanged(activeContract);
    //           } else if (null !== asfPremiumContract) {
    //             this.contractControl.setValue(asfPremiumContract.uuid);
    //             this.contractChanged(asfPremiumContract);
    //           }
    //
    //
    //         this.ofwcaRegistrationInfo = ofwcaRegistrationInfo;
    //
    //       });
    //   });

    this.assetsRegionalControl.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((assetsRegionalId: string) => {
        if (assetsRegionalId === 'd095058c-cf4e-4928-be5a-ae55af272d4b') {
          this.dictService.getId(PARTNER_TAGS_PROFIT, DICT_TYPE_PARTNER_TAGS)
            .subscribe((dictId: number) => {
              const tags = [...this.tags.value];
              if (!tags.includes(dictId)) {
                tags.push(dictId);
              }
              this.tags.reset(tags);
            });
        }
      });

    this.formOfBusiness.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe((dictId: number) => {
        this.dictService.getKey(dictId)
          .subscribe((dictKey: string) => {
            if ([FORM_OF_BUSINESS_SOLE_PROPRIETORSHIP, FORM_OF_BUSINESS_PARTNERSHIP].includes(dictKey) ||
              [FORM_OF_BUSINESS_FOREIGN_ACTIVITIES, FORM_OF_BUSINESS_PARTNERSHIP].includes(dictKey)) {
              this.requiredKrsNumber = false;
              this.partnerForm.get('krs').setValidators([]);
            } else if (dictKey === FORM_OF_BUSINESS_NONE_PROPRIETORSHIP){
              this.requiredKrsNumber = false;
              this.partnerForm.get('krs').setValidators([]);
            } else {
              this.partnerForm.get('krs').setValidators([Validators.required]);
              this.requiredKrsNumber = true;
            }

            this.partnerForm.get('krs').updateValueAndValidity();

            if (dictKey === FORM_OF_BUSINESS_NONE_PROPRIETORSHIP){
             this.partnerForm.get('nip').disable();
             this.partnerForm.get('regon').disable();
              this.partnerForm.get('krs').disable();
              this.partnerForm.get('nip').setValidators([]);
              this.partnerForm.get('regon').setValidators([]);
              this.partnerForm.get('nip').setValue('');
              this.partnerForm.get('regon').setValue('');
              this.partnerForm.get('krs').setValue('');
              this.partnerForm.get('owner').setValidators([Validators.required]);
              this.formOfBusinessNonePartnership = true;
              if (this.ofwcaSelect){
                this.ofwcaSelectUpdate(this.ofwcaSelect);
              }
            } else{
              this.partnerForm.get('nip').enable();
              this.partnerForm.get('regon').enable();
              this.partnerForm.get('krs').enable();
              this.partnerForm.get('nip').setValidators([Validators.required]);
              this.partnerForm.get('regon').setValidators([Validators.required]);
              this.partnerForm.get('owner').setValidators([]);
              this.formOfBusinessNonePartnership = false;
            }
          });
      });
    this.ofwcaSubject
      .pipe(takeUntil(this.destroyed$))
      .subscribe((response) => {
        this.ofwcas = response.items;
      });
    this.disableOfwca();
  }

  ngAfterViewInit(): void {
    if (this.partner) {
      this.partner
        .pipe(
          takeUntil(this.destroyed$),
          delay(0)
        )
        .subscribe((partner: Partner) => {
          if (partner) {
            this.partnerObject = partner;
            this.partnerUuid = partner?.uuid;
            this.initialize(partner);
            this.partnerObject.tags.forEach(tag => {
              if (this.AUTOMATIC_TAGS.includes(tag.key)){
                this.dictService.getId(tag.key, tag.type);
                this.nonEditableTags.push(tag);
              }
            });
          }
          if (partner.ofwcaPartner === true){
            this.partnerForm.get('representation').disable();
          }
        });
    } else {
      of(true)
        .pipe(
          delay(0)
        ).subscribe(() => {
          this.addRepresentation();
          this.addBusinessEntities();
          this.addEmail('mainEmails');
          this.addPhone('mainPhones');
          this.setRegional();
      });
    }
  }
  // ofwcaSelect(ofwca: Ofwca): void {
  //   const filters: any = {
  //     onlyNew: 1,
  //     ofwca: ofwca?.uuid,
  //   };
  //
  //
  //   this.ofwcaFirstName.setValue(ofwca.firstName);
  //   this.ofwcaSecondName.setValue(ofwca.secondName);
  //   this.ofwcaLastName.setValue(ofwca.lastName);
  //   this.ofwcaPesel.setValue(ofwca.pesel);
  //   this.ofwcaFamilyName.setValue(ofwca.familyName);
  //   this.ofwcaMothersMaidenName.setValue(ofwca.mothersMaidenName);
  //   this.ofwcaMothersName.setValue(ofwca.mothersName);
  //   this.ofwcaFathersName.setValue(ofwca.fathersName);
  //   this.ofwcaBirthPlace.setValue(ofwca.birthPlace);
  //   this.ofwcaBirthDate.setValue(ofwca.birthDate);
  //   this.ofwcaSex.setValue(ofwca.sex?.id);
  //   this.ofwcaEducation.setValue(ofwca.education?.id);
  //   this.ofwcaStatus.setValue(ofwca.status?.id);
  //   this.ofwcaId.setValue(ofwca.uuid);
  // }
  contractChanged(contract: Contract): void {
    const filters: any = {
      onlyNew: 1,
      contract: contract?.uuid,
      status: contract?.status,
      ofwca: contract?.ofwca,
    };
    this.commissionSettlementService.loadList(
      0,
      999,
      filters,
      this.settlementsSubject
    );

    this.ofwcaFirstName.setValue(contract.ofwca.firstName);
    this.ofwcaSecondName.setValue(contract.ofwca.secondName);
    this.ofwcaLastName.setValue(contract.ofwca.lastName);
    this.ofwcaPesel.setValue(contract.ofwca.pesel);
    this.ofwcaFamilyName.setValue(contract.ofwca.familyName);
    this.ofwcaMothersMaidenName.setValue(contract.ofwca.mothersMaidenName);
    this.ofwcaMothersName.setValue(contract.ofwca.mothersName);
    this.ofwcaFathersName.setValue(contract.ofwca.fathersName);
    this.ofwcaBirthPlace.setValue(contract.ofwca.birthPlace);
    this.ofwcaBirthDate.setValue(contract.ofwca.birthDate);
    this.ofwcaSex.setValue(contract.ofwca.sex?.id);
    this.ofwcaEducation.setValue(contract.ofwca.education?.id);
    this.ofwcaStatus.setValue(contract.ofwca.status?.id);
    this.ofwcaId.setValue(contract.ofwca.uuid);
    this.ofwcaContractId.setValue(contract.uuid);
  }
  // contractChanged(contract: Contract): void {
  //   this.contractCompanyId.next(contract.company.id);
  //   this.selectedContract = contract;
  // }
  setRegional(): void {
    this.auth.getProfile()
      .pipe(first())
      .subscribe((profile: Profile) => {
        if (profile.regionalId) {
          this.assetsRegionalControl.setValue(profile.regionalId);
        }
      });
  }
  getGus(): void {
    this.snack.open('Pobieranie danych z GUS');
    this.partnerService.gusInformation(this.partnerForm.get('nip').value)
    .subscribe((e: PartnerGus) => {
      this.snack.open('Pobrano dane z GUS','' , {duration: 2000});
      this.partnerForm.get('fullName').setValue(e.fullName);
      this.partnerForm.get('shortName').setValue(e.shortName);
      this.statusGus = e.status;
      this.partnerForm.get('gusStatus').setValue(e.status?.id);
      this.partnerForm.get('legalForm').setValue(e.legalForm?.id);
      this.partnerForm.get('formOfBusiness').setValue(e.formOfBusiness?.id);
      this.partnerForm.get('krs').setValue(e.krs);
      e.businessEntities
        .forEach((businessEntities: any) => this.addBusinessEntities(
          businessEntities.businessFullName,
          businessEntities.businessFirstName,
          businessEntities.businessLastName,
          businessEntities.businessNip,
          businessEntities.businessRegon,
          null,
          null,
          businessEntities.businessStreet,
          businessEntities.businessHouseNumber,
          businessEntities.businessApartmentNumber,
          businessEntities.businessCity,
          businessEntities?.businessZipCode,
          businessEntities?.businessState,
          businessEntities.businessPostCity,
          businessEntities.businessDistrict,
          businessEntities.businessCommune));
      if (e.address.state){
        e.address.stateId = e.address.state.id;
      }
      this.formHelper.setAddress( e.address, this.headquartersAddress);
      this.partnerForm.get('regon').setValue(e.regon);
      this.partnerForm.get('hasPkd').setValue(e.pkd);
      }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych z GUS', error.status.toString(), {
        duration: 2000
      });
    });
  }

  initialize(partner: Partner): void {
    of(partner)
      .pipe(
        tap(() => {
          this.mainEmails = [];
          this.additionalEmails = [];
          this.mainPhones = [];
          this.additionalPhones = [];
          this.representationFormArray = [];
          this.businessEntitiesFormArray = [];

          this.partnerForm.reset({
            legalForm: partner.legalForm?.id,
            formOfBusiness: partner.formOfBusiness?.id,
            fullName: partner.fullName,
            shortName: partner.shortName,
            nip: partner.nip,
            regon: partner.regon,
            krs: partner.krs,
            accountNumber: partner.accountNumber,
            vatPayer: partner.vatPayer,
            activeVatPayer: partner.activeVatPayer,
            contestMessageConsent: partner.contestMessageConsent,
            productMessageConsent: partner.productMessageConsent,
            owner: partner.owner?.uuid || '',
            assetsRegional: partner.assetsRegional?.uuid || '',
            lifeRegional: partner.lifeRegional?.uuid || '',
            communicationAddressSameAsHeadquarters: partner.communicationAddress.uuid === partner.headquartersAddress.uuid,
            tags: partner.tags.map((tag: Dictionary) => tag.id),
            verified: partner.verified,
            note: partner.note,
            profitNumber: partner.profitNumber,
            parentPartner: partner.parentPartner?.uuid || '',
            checkoutMethod: partner.checkoutMethod,
            selfBilling: partner.selfBilling,
            hiperioLogin: partner.hiperioLogin,
            hiperioEmail: partner.hiperioEmail,
            ofwcaPartner: partner.ofwcaPartner,
            ofwcaFirstName: partner.ofwcaFirstName,
            ofwcaSecondName: partner.ofwcaSecondName,
            ofwcaLastName: partner.ofwcaLastName,
            ofwcaPesel: partner.ofwcaPesel,
            withoutPesel: !partner.ofwcaPesel,
            ofwcaFamilyName: partner.ofwcaFamilyName,
            ofwcaMothersMaidenName: partner.ofwcaMothersMaidenName,
            ofwcaMothersName: partner.ofwcaMothersName,
            ofwcaFathersName: partner.ofwcaFathersName,
            ofwcaBirthPlace: partner.ofwcaBirthPlace,
            ofwcaBirthDate: partner.ofwcaBirthDate ? moment(partner.ofwcaBirthDate) : '',
            ofwcaSex: partner.ofwcaSex?.id || '',
            ofwcaEducation: partner.ofwcaEducation?.id || '',
            ofwcaStatus: partner.ofwcaStatus?.id || '',
            ofwcaId: partner.ofwcaId?.uuid,
            ofwcaContractId: partner.ofwcaContractId?.uuid,
            gusStatus: partner.gusStatus?.id,
            hasPkd: partner.hasPkd,
            invoiceGenerateBlockAsf: partner.invoiceGenerateBlockAsf,
            invoiceGenerateBlockPremium: partner.invoiceGenerateBlockPremium,
            settlementSendBlockAsf: partner.settlementSendBlockAsf,
            settlementSendBlockPremium: partner.settlementSendBlockPremium,
            invoiceAddBlockAsf: partner.invoiceAddBlockAsf,
            invoiceAddBlockPremium: partner.invoiceAddBlockPremium,
            foreignActivities: partner.foreignActivities,
            foreignActivitiesRegon : partner.regon,
            foreignActivitiesNip : partner.nip,
            newPartner: partner.newPartner,
            overcommissionPartner: partner.overcommissionPartner?.uuid || '',

          });
          if (partner.accountNumber){
             this.partnerForm.get('accountNumber').disable();
          }

          if (partner.formOfBusiness.key === FORM_OF_BUSINESS_NONE_PROPRIETORSHIP){
            this.ofwcaSelect = partner.owner;
            this.formOfBusinessNonePartnership = true;
          }

          partner.emails.filter((email: EmailAddress) => email.main)
            .forEach((email: EmailAddress) => this.addEmail('mainEmails', email.uuid, email.address, email.name,
              email.marketing, email.product, email.billing, email.lead));
          partner.emails.filter((email: EmailAddress) => !email.main)
            .forEach((email: EmailAddress) => this.addEmail('additionalEmails', email.uuid, email.address,
              email.name, email.marketing, email.product, email.billing, email.lead));


          partner.phones.filter((phone: PhoneNumber) => phone.main)
            .forEach((phone: PhoneNumber) => this.addPhone('mainPhones', phone.uuid, phone.number, phone.name,
              phone.marketing, phone.product, phone.billing));
          partner.phones.filter((phone: PhoneNumber) => !phone.main)
            .forEach((phone: PhoneNumber) => this.addPhone('additionalPhones', phone.uuid, phone.number,
              phone.name, phone.marketing, phone.product, phone.billing));

          partner.representation
            .forEach((representation: PartnerRepresentation) => this.addRepresentation(representation.firstName,
              representation.lastName, representation.functionPartner));
          partner.businessEntities
            .forEach((businessEntities: PartnerBusinessEntities) => this.addBusinessEntities(businessEntities.businessFullName,
              businessEntities.businessFirstName, businessEntities.businessLastName, businessEntities.businessNip,
              businessEntities.businessRegon, businessEntities.businessEmail, businessEntities.businessPhone,
              businessEntities.businessStreet, businessEntities.businessHouseNumber, businessEntities.businessApartmentNumber,
              businessEntities.businessCity, businessEntities.businessZipCode, businessEntities.businessState,
              businessEntities.businessPostCity, businessEntities.businessDistrict, businessEntities.businessCommune));

          this.formHelper.setAddress(partner.headquartersAddress, this.headquartersAddress);
          if (partner.foreignActivities) {
            this.formHelper.setAddress(this.headquartersAddress.value, this.foreignActivitiesHeadquartersAddress);
          }
        }),
        delay(0),
        map(() => partner.communicationAddress),
        tap((address: Address) => {
          if (partner.communicationAddress.uuid !== partner.headquartersAddress.uuid) {
            this.formHelper.setAddress(address, this.communicationAddress);
          }
        }),
        delay(0),
        tap(() => this.partnerForm.markAllAsTouched())
      ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  addRepresentation(firstName?: string, lastName?: string, functionPartner?: string): void {
    this.representationFormArray.push(new FormGroup({
      firstName: new FormControl(firstName || '', [Validators.required]),
      lastName: new FormControl(lastName || '', [Validators.required]),
      functionPartner: new FormControl(functionPartner || ''),
    }));
    this.updateRepresentationFormArray();
  }

  addBusinessEntities(businessFullName?: string, businessFirstName?: string, businessLastName?: string, businessNip?: string,
                      businessRegon?: string, businessEmail?: string, businessPhone?: string,   businessStreet?: string,
                      businessHouseNumber?: string, businessApartmentNumber?: string, businessCity?: string, businessZipCode?: string,
                      businessState?: Dictionary, businessPostCity?: string, businessDistrict?: string, businessCommune?: string): void {
    this.businessEntitiesFormArray.push(new FormGroup({
      businessFullName: new FormControl(businessFullName || '', [Validators.required]),
      businessFirstName: new FormControl(businessFirstName || '', [Validators.required]),
      businessLastName: new FormControl(businessLastName || '', [Validators.required]),
      businessNip: new FormControl(businessNip || '', [Validators.required, validNip()]),
      businessRegon: new FormControl(businessRegon || '', [Validators.required, validRegon()]),
      businessEmail: new FormControl(businessEmail || '', [Validators.required, Validators.email]),
      businessPhone: new FormControl(businessPhone || '', [Validators.required, validPhoneNumber()]),
      businessStreet:  new FormControl(businessStreet || '',  [Validators.required]),
      businessHouseNumber:  new FormControl(businessHouseNumber || '', [Validators.required]),
      businessApartmentNumber:  new FormControl(businessApartmentNumber || '', ),
      businessCity:  new FormControl(businessCity || '', [Validators.required]),
      businessZipCode:  new FormControl(businessZipCode || '', [Validators.required]),
      businessState:  new FormControl(businessState?.id || '', [Validators.required]),
      businessPostCity:  new FormControl(businessPostCity || '', [Validators.required]),
      businessDistrict:  new FormControl(businessDistrict || '',  [Validators.required]),
      businessCommune:  new FormControl(businessCommune || '',  [Validators.required]),
    }));
    this.updateBusinessEntitiesFormArray();
  }
  updateBusinessEntitiesFormArray(): void {
    this.partnerForm.setControl('businessEntities', new FormArray(this.businessEntitiesFormArray, [ArrayValidators.minLength(2)]));
  }
  removeBusinessEntities(index: number): void {
    this.businessEntitiesFormArray.splice(index, 1);
    this.updateBusinessEntitiesFormArray();
  }
  updateRepresentationFormArray(): void {
    this.partnerForm.setControl('representation', new FormArray(this.representationFormArray, [ArrayValidators.minLength(1)]));
  }

  removeRepresentation(index: number): void {
    this.representationFormArray.splice(index, 1);
    this.updateRepresentationFormArray();
  }
  updateDataBasedOnPesel(ofwcaPesel?: string): void {
    if (!ofwcaPesel) {
      return;
    }

    const result = this.peselHelper.decode(ofwcaPesel);
    if (result.valid) {
      this.getControl('ofwcaBirthDate').setValue(result.birthDate);
      this.dictService.getId(result.male ? SEX_MALE : SEX_FEMALE, DICT_TYPE_SEX)
        .subscribe((val: number) => this.getControl('Sex').setValue(val));
    }
  }

  sendForm(): void {
    if (this.partnerForm.get('accountNumber').value === 'PL' ){
      this.partnerForm.get('accountNumber').reset();
    }
    if (this.partnerForm.get('foreignActivities').value){
      this.formHelper.setAddress( this.foreignActivitiesHeadquartersAddress.value, this.headquartersAddress);
    }
    if (!this.partnerForm.valid) {
      this.partnerForm.markAllAsTouched();
      this.snackBar.open('Wypełnij lub popraw wszystkie wymagane pola', '', {
        duration: 2000,
      });
      return;
    }

    this.nonEditableTags.forEach(tag => {
        this.addTags(tag.key, tag.type);
    });

    this.processingRequest = true;
    this.formHelper.removeBackendErrorState(this.partnerForm, this.errors);
    this.errors = {};

    const formData = this.partnerForm.getRawValue();

    formData.representation?.forEach((rep: any, index: number) => {
      if (typeof rep.functionPartner === 'object') {
      }
    });

    const payload = {
      ...formData,
      representation: formData.representation?.map((rep: any) => ({
        ...rep,
        functionPartner: rep.functionPartner?.name || rep.functionPartner || null
      }))
    };

    this.partnerService.sendForm(payload, this.partnerObject?.uuid)
      .pipe(take(1))
      .subscribe((response: Uuid) => {
        this.snackBar.open(this.partnerObject ? 'Pomyślnie zaktualizowano obiekt partnera' : 'Pomyślnie utworzono obiekt partnera', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        if (!this.partnerObject) {
          this.router.navigate(['/partnerzy/szczegoly', response.uuid]);
        } else {
          this.closeModification.emit();
        }
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;

        if (error.status === 404) {
          this.snackBar.open('Rekord został usunięty lub przeniesiony', error.status.toString(), {
            duration: 2000,
          });
          this.router.navigate(['/partnerzy']);
          return;
        }

        this.snackBar.open('Podczas tworzenia obiektu partnera wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });

        if (error.status === 400) {
          this.errors = error.error.error.list;
          this.formHelper.setBackendErrorState(this.partnerForm, this.errors);
        }
      })
    ;
  }

  cancel(): void {
    if (!this.partnerObject) {
      this.router.navigate(['/partnerzy']);
    } else {
      this.closeModification.emit();
    }
  }

  removeEmail(i: number, type: string): void {
    this[type].splice(i, 1);
    this.refreshEmailControl(type);
  }

  refreshEmailControl(type: string): void {
    const validators = type === 'mainEmails' ? [ArrayValidators.minLength(1)] : [];
    this.partnerForm.setControl(type, this.fb.array(this[type], validators));
  }

  addEmail(type: string, recordUuid?: string, email?: string, name?: string, marketing: boolean = false, product: boolean = false, billing: boolean = false, lead: boolean = false): void {
    this[type].push(this.fb.group({
      uuid: this.fb.control(recordUuid ?? uuid.v4(), [Validators.required]),
      email: this.fb.control(email ?? '', [Validators.required, Validators.email]),
      name: this.fb.control(name ?? ''),
      marketing: this.fb.control(marketing ?? ''),
      product: this.fb.control(product ?? ''),
      billing: this.fb.control(billing ?? ''),
      lead: this.fb.control(lead ?? ''),
    }));
    this.refreshEmailControl(type);
  }

  addPhone(type: string, recordUuid?: string, phone?: string, name?: string, marketing: boolean = false, product: boolean = false, billing: boolean = false): void {
    this[type].push(this.fb.group({
      uuid: this.fb.control(recordUuid ?? uuid.v4(), [Validators.required]),
      phone: this.fb.control(phone ?? '', [Validators.required, validPhoneNumber()]),
      name: this.fb.control(name ?? ''),
      marketing: this.fb.control(marketing ?? ''),
      product: this.fb.control(product ?? ''),
      billing: this.fb.control(billing ?? ''),
    }));
    this.refreshPhoneControl(type);
  }

  refreshPhoneControl(type: string): void {
    const validators = type === 'mainPhones' ? [ArrayValidators.minLength(1)] : [];
    this.partnerForm.setControl(type, this.fb.array(this[type], validators));
  }

  removePhone(i: number, type: string): void {
    this[type].splice(i, 1);
    this.refreshPhoneControl(type);
  }
  public getControl(name: string): FormControl {
    return this.partnerForm.get(name) as FormControl;
  }
  updatePeselControl(withoutPesel: boolean): void {
    const peselControl = this.partnerForm.get('ofwcaPesel');

    if (withoutPesel) {
      peselControl.reset();
      peselControl.setValidators([]);
      peselControl.disable();
    } else {
      peselControl.setValidators([Validators.required]);
      peselControl.enable();
    }
  }
  changeOfwcaPartner(ofwcaPartner: any): void {
     if (
       ofwcaPartner === false
       && this.partnerObject?.ofwcaPartner === false
       && !(this.partnerObject?.ofwcaPesel && this.partnerObject?.ofwcaLastName )
     ){
       this.radioOff = true;
     }
    if (!ofwcaPartner) {
      return;
    }
    if (ofwcaPartner?.valueOf() === '0') {
      this.hidePartner = false;
      this.disableOfwca();
      this.enablePartner();
      this.disableContract.emit(false);


    } else {
      // this.hidePartner = true;
      // this.disablePartner();
      // this.enableOfwca();
      // this.disableContract.emit(true);

    }
  }
  disableOfwca(): void{
    this.partnerForm.get('ofwcaFirstName').disable();
    this.partnerForm.get('ofwcaFirstName').setValidators([]);
    this.partnerForm.get('ofwcaLastName').disable();
    this.partnerForm.get('ofwcaLastName').setValidators([]);
    this.partnerForm.get('ofwcaFamilyName').disable();
    this.partnerForm.get('ofwcaFamilyName').setValidators([]);
    this.partnerForm.get('ofwcaMothersMaidenName').disable();
    this.partnerForm.get('ofwcaMothersMaidenName').setValidators([]);
    this.partnerForm.get('ofwcaMothersName').disable();
    this.partnerForm.get('ofwcaMothersName').setValidators([]);
    this.partnerForm.get('ofwcaFathersName').disable();
    this.partnerForm.get('ofwcaFathersName').setValidators([]);
    this.partnerForm.get('ofwcaBirthPlace').disable();
    this.partnerForm.get('ofwcaBirthPlace').setValidators([]);
    this.partnerForm.get('ofwcaBirthDate').disable();
    this.partnerForm.get('ofwcaBirthDate').setValidators([]);
    this.partnerForm.get('ofwcaSex').disable();
    this.partnerForm.get('ofwcaSex').setValidators([]);
    this.partnerForm.get('ofwcaEducation').disable();
    this.partnerForm.get('ofwcaEducation').setValidators([]);
    this.partnerForm.get('ofwcaPesel').disable();
    this.partnerForm.get('ofwcaPesel').setValidators([]);
  }
  enableOfwca(): void{
    this.partnerForm.get('ofwcaFirstName').enable();
    this.partnerForm.get('ofwcaFirstName').setValidators([Validators.required]);
    this.partnerForm.get('ofwcaLastName').enable();
    this.partnerForm.get('ofwcaLastName').setValidators([Validators.required]);
    this.partnerForm.get('ofwcaFamilyName').enable();
    this.partnerForm.get('ofwcaFamilyName').setValidators([Validators.required]);
    this.partnerForm.get('ofwcaMothersMaidenName').enable();
    this.partnerForm.get('ofwcaMothersMaidenName').setValidators([Validators.required]);
    this.partnerForm.get('ofwcaMothersName').enable();
    this.partnerForm.get('ofwcaMothersName').setValidators([Validators.required]);
    this.partnerForm.get('ofwcaFathersName').enable();
    this.partnerForm.get('ofwcaFathersName').setValidators([Validators.required]);
    this.partnerForm.get('ofwcaBirthPlace').enable();
    this.partnerForm.get('ofwcaBirthPlace').setValidators([Validators.required]);
    this.partnerForm.get('ofwcaBirthDate').enable();
    this.partnerForm.get('ofwcaBirthDate').setValidators([Validators.required]);
    this.partnerForm.get('ofwcaSex').enable();
    this.partnerForm.get('ofwcaSex').setValidators([Validators.required]);
    this.partnerForm.get('ofwcaEducation').enable();
    this.partnerForm.get('ofwcaEducation').setValidators([Validators.required]);
    this.partnerForm.get('ofwcaPesel').enable();
    this.partnerForm.get('ofwcaPesel').setValidators([Validators.required]);
  }
  disablePartner(): void{
    this.partnerForm.get('fullName').disable();
    this.partnerForm.get('fullName').setValidators([]);
    this.partnerForm.get('shortName').disable();
    this.partnerForm.get('shortName').setValidators([]);
    this.partnerForm.get('nip').disable();
    this.partnerForm.get('nip').setValidators([]);
    this.partnerForm.get('regon').disable();
    this.partnerForm.get('regon').setValidators([]);
    this.partnerForm.get('krs').disable();
    this.partnerForm.get('krs').setValidators([]);

    this.partnerForm.get('legalForm').disable();
    this.partnerForm.get('legalForm').setValidators([]);
    this.partnerForm.get('formOfBusiness').disable();
    this.partnerForm.get('formOfBusiness').setValidators([]);
  }
  enablePartner(): void{
    this.partnerForm.get('fullName').enable();
    this.partnerForm.get('fullName').setValidators([Validators.required]);
    this.partnerForm.get('shortName').enable();
    this.partnerForm.get('shortName').setValidators([Validators.required]);
    this.partnerForm.get('legalForm').enable();
    this.partnerForm.get('legalForm').setValidators([Validators.required]);
    this.partnerForm.get('nip').enable();
    this.partnerForm.get('nip').setValidators([Validators.required]);
    this.partnerForm.get('regon').enable();
    this.partnerForm.get('regon').setValidators([Validators.required]);
    this.partnerForm.get('krs').enable();
    this.partnerForm.get('krs').setValidators([Validators.required]);
    this.partnerForm.get('formOfBusiness').enable();
    this.partnerForm.get('formOfBusiness').setValidators([Validators.required]);
  }
  addTags($key: any, $type: any): void{
    this.dictService.getId($key, $type)
      .subscribe((dictId: number) => {
        const tags = [...this.tags.value ?? []];
        if (!tags.includes(dictId)) {
          tags.push(dictId);
        }
        this.tags.reset(tags);
      });
  }

  ofwcaSelectUpdate(ofwca: Ofwca): void {
    this.ofwcaSelect = ofwca;
    if (this.formOfBusinessNonePartnership){
      this.ofwcaSelect = ofwca;
      this.partnerForm.get('fullName').setValue(this.ofwcaSelect.fullName);
      this.partnerForm.get('shortName').setValue(this.ofwcaSelect.fullName);
      this.removePhone(0, 'mainPhones');
      this.ofwcaSelect.phones.filter((phone: PhoneNumber) => phone.main)
        .forEach((phone: PhoneNumber) => this.addPhone('mainPhones', phone.uuid, phone.number, phone.name,
          phone.marketing, phone.product, phone.billing));
      this.ofwcaSelect.phones.filter((phone: PhoneNumber) => !phone.main)
        .forEach((phone: PhoneNumber) => this.addPhone('additionalPhones', phone.uuid, phone.number,
          phone.name, phone.marketing, phone.product, phone.billing));
      // this.removePhone(0, 'phones');
      this.removeEmail(0, 'mainEmails');
      this.ofwcaSelect.emails.filter((email: EmailAddress) => email.main)
        .forEach((email: EmailAddress) => this.addEmail('mainEmails', email.uuid, email.address, email.name,
          email.marketing, email.product, email.billing, email.lead));
      this.ofwcaSelect.emails.filter((email: EmailAddress) => !email.main)
        .forEach((email: EmailAddress) => this.addEmail('additionalEmails', email.uuid, email.address,
          email.name, email.marketing, email.product, email.billing, email.lead));
      if ( this.ofwcaSelect?.livingAddress) {
        this.formHelper.setAddress(this.ofwcaSelect?.livingAddress, this.headquartersAddress);
      }
      if (this.ofwcaSelect?.communicationAddress) {
        this.formHelper.setAddress(this.ofwcaSelect?.communicationAddress, this.communicationAddress);
      }
      this.partnerForm.get('communicationAddressSameAsHeadquarters').setValue(true);
      // this.removeEmail(0, 'emails');
    }
  }
  // removeTags($key: any, $type: any): void {
  // this.dictService.getId($key, $type)
  //   .subscribe((dictId: number) => {
  //     const tags = [...this.tags.value];
  //     if (!tags.includes(dictId)) {
  //       tags.push(dictId);
  //     }
  //     this.tags.res;
  //   });
  //
  // }

}
